export default{
  data(){
    return{
      sexes: [
        {"id":"male","label":"Male"},
        {"id":"female","label":"Female"},
      ],
    }
  }
}